import { definePermissions } from '@eis/core';

/**
 * Partner permission catalog (Addendum A.2 "ownership"; SDD-014 §8).
 *
 * This file is the ONLY place in the module where permission literals may appear — ESLint
 * enforces that. Everything else references `partnersPermissions.partners.view`, so a typo is a
 * compile error rather than a permission that silently denies in production.
 *
 * The domain is the Partner service's own: the image guards every partner RPC with
 * `EISPermissions.PartnerManagement.Partners.View | Create | Update | Delete` (PROBE.md §2), and
 * these four keys are those four, spelled in the platform's dotted grammar. The console gate is
 * UX; the service is the wall; both fail closed (SDD-014 §8). `partner-management.partners.create`
 * was declared by the insurance module first (SDD-013 D-L4 ii, prompt 19) because a lead's draft
 * needed it; ownership moves HERE with prompt 20 (R-12) — the insurance module keeps a marked
 * REFERENCE to the same key for its own gates (`permissions-registry.json` lists the key once).
 *
 * `delete`: the probe proved the endpoint usable (soft delete, versions stay readable — PROBE.md
 * §6), so the dialog exists and is the admin's alone (SDD-014 §6.4, §8).
 */
export const partnersPermissions = definePermissions({
  partners: {
    domain: 'partner-management',
    entity: 'partners',
    actions: ['view', 'create', 'update', 'delete'],
  },
});
